import {storage, Key} from '@soluto-private/mx-context';

export const replaceTemplateString = (
  str: string,
  templateVars: Record<string, string>,
): string => {
  const lang = storage.get(Key.Language);
  for (const template in templateVars) {
    let value = templateVars[template];

    // TODO: remove
    if(lang === "fr-CA" && value === "Other Android"){
      value = "Android - Autre";
    }

    str = str.replace(`\$\{${template}\}`, value);
  }
  return str;
};
